import { Skeleton } from '@mui/material';
import { IconBed } from '@tabler/icons-react';

const BoatRoomSkeleton = () => {
  return (
    <div className="mt-8 md:flex flex-col gap-6 items-start">
      {/* Header */}
      <div className="flex flex-col items-start gap-2 flex-grow flex-shrink-0">
        <div className="flex items-center gap-2 text-neutral-800">
          <IconBed />
          <Skeleton variant="text" width={100} height={32} />
        </div>
        <Skeleton variant="text" width="80%" height={24} />
      </div>

      {/* Info Message */}
      <div className="flex p-4 mt-4 items-center content-center gap-3 self-stretch flex-wrap bg-neutral-20 rounded-lg">
        <div className="flex items-center gap-3 flex-grow flex-shrink-0 flex-1">
          <Skeleton variant="circular" width={16} height={16} />
          <Skeleton variant="text" width="60%" height={20} />
        </div>
      </div>

      {/* Room Cards Skeleton */}
      {[1, 2, 3].map(item => (
        <div
          key={item}
          className="flex flex-col items-start gap-6 self-stretch mt-4 md:flex-row"
        >
          {/* Room Image */}
          <Skeleton
            variant="rectangular"
            className="h-52 w-full rounded-2xl md:h-[16.25rem] md:w-[16.5rem]"
          />

          {/* Room Details */}
          <div className="flex flex-col items-start gap-4 self-stretch">
            <Skeleton variant="text" width="50%" height={28} />

            <div className="flex flex-col items-start gap-3 self-stretch text-neutral-500">
              {[1, 2, 3].map(subItem => (
                <div
                  key={subItem}
                  className="flex w-36 min-w-[9rem] items-center gap-2"
                >
                  <Skeleton variant="circular" width={20} height={20} />
                  <Skeleton variant="text" width="70%" height={20} />
                </div>
              ))}
            </div>

            <Skeleton variant="text" width={120} height={24} />

            {/* Desktop Version Buttons */}
            <div className="hidden md:flex items-center justify-between gap-6 self-stretch mt-6">
              <div className="flex items-baseline gap-2">
                <Skeleton variant="text" width={80} height={28} />
                <Skeleton variant="text" width={60} height={20} />
              </div>
              <div className="flex flex-col justify-center items-end gap-2">
                <div className="flex items-center gap-3">
                  <Skeleton variant="rectangular" width={32} height={32} />
                  <Skeleton variant="text" width={50} height={24} />
                  <Skeleton variant="rectangular" width={32} height={32} />
                </div>
                <Skeleton
                  variant="rectangular"
                  width={100}
                  height={24}
                  className="rounded-full"
                />
              </div>
            </div>
          </div>

          {/* Mobile Version Buttons */}
          <div className="flex items-center justify-between gap-6 self-stretch mt-6 md:hidden">
            <div className="flex items-baseline gap-2">
              <Skeleton variant="text" width={80} height={28} />
              <Skeleton variant="text" width={60} height={20} />
            </div>
            <div className="flex flex-col justify-center items-end gap-2">
              <div className="flex items-center gap-3">
                <Skeleton variant="rectangular" width={32} height={32} />
                <Skeleton variant="text" width={50} height={24} />
                <Skeleton variant="rectangular" width={32} height={32} />
              </div>
              <Skeleton
                variant="rectangular"
                width={100}
                height={24}
                className="rounded-full"
              />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default BoatRoomSkeleton;
